import { Button, FloatingLabel, Form, Offcanvas } from "olive-react-myoneui";
import DropdownCommon from "../component/DropdownCommon";
import { useState } from "react";

function EditOffcanvas({
  show,
  onClose,
  updateTopics,
  subjects,
  selectedSubject,
  setSelectedSubject,
  setTopics,
  topics,
  topicsId,
}) {
  console.log("top.....",topics)
  const subjectHandler = (data) => {
    setSelectedSubject(data);
  };

  return (
    <>
      <Offcanvas className="pb-0" show={show} onHide={onClose} placement="end">
        <Offcanvas.Header
          closeButton
          backButton="Close"
          icon="close"
          className="pb-0"
        >
          <Offcanvas.Title>Edit Topics</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <p className="help-text fs-6 fw-semibold">
            Please fill the form below and Edit topics.
          </p>

          <FloatingLabel controlId="topicsId" label="Topics" className="mb-4">
            <Form.Control
              type="text"
              placeholder="Topics"
              value={topics}
              onChange={(e) => setTopics(e.target.value)}
            />
          </FloatingLabel>
          <DropdownCommon
             className="mb-4"
            name="subject"
            selectedValue={selectedSubject}
            setSelectedValue={setSelectedSubject}
            items={subjects}
            label="Subject"
            // onChange={subjectHandler}
          />
        </Offcanvas.Body>
        <Offcanvas.Footer>
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={()=>updateTopics(topics,selectedSubject?._id,topicsId)} >
            Save
          </Button>
        </Offcanvas.Footer>
      </Offcanvas>
    </>
  );
}

export default EditOffcanvas;
